export default "__VITE_ASSET__72b6e945__"